import { composeInfiniteQueryKey } from './composeInfiniteQueryKey.js';
import { composeQueryKey } from './composeQueryKey.js';

/**
 * Calls a query client method with parameters and options,
 * and automatically composes the `QueryKey` based on the schema and parameters.
 */ function callQueryClientMethodWithQueryKey(queryFilterMethod, schema, infinite, args) {
    const parameters = args.length > 1 ? args[0] : undefined;
    const queryClient = args[args.length - 1];
    if (!queryClient) throw new Error('queryClient is required');
    if (!queryClient[queryFilterMethod]) throw new Error(`queryClient is invalid, ${queryFilterMethod} method does not exist`);
    const queryKey = Array.isArray(parameters) ? parameters : infinite ? composeInfiniteQueryKey(schema, parameters) : composeQueryKey(schema, parameters);
    // @ts-expect-error - Too complex to type
    return queryClient[queryFilterMethod](queryKey, ...args.slice(1, -1));
}

export { callQueryClientMethodWithQueryKey };
//# sourceMappingURL=callQueryClientMethodWithQueryKey.js.map
